<template>
        <el-dialog title="Club Tables" :visible.sync="showPopup" class="my-dialog-class" >
        <el-form label-position="top" :inline="false" :rules="rules" label-width="100%"  :model='selectedObject'  ref='my-form' @submit.prevent="save" v-loading="loadingVisible" >
            <el-row :gutter="15" >

            <el-col :md='12'>
                <el-form-item label='Club' >
                    <el-select v-model='selectedObject.IdClub' class='full-width'>        
                        <el-option v-for='item in Info.clubs' :key="'clubs' + item.Id" :label='item.Name' :value='item.Id'></el-option>
                    </el-select>
                </el-form-item>
            </el-col>    
            <el-col :md='12'>
                <el-form-item label='Name' >
                    <el-input  class='full-width' v-model='selectedObject.Name' />
                </el-form-item>
            </el-col>
            <el-col :md='24'>
                <el-form-item label='Description' >
                    <el-input type="textarea"  class='full-width' v-model='selectedObject.Description' />
                </el-form-item>
            </el-col>
            <el-col :md='8'>
                <el-form-item label='MinimumAmmount' >
                    <el-input-number class='full-width' v-model='selectedObject.MinimumAmmount' :precision='0' :max='999999'></el-input-number>
                </el-form-item>
            </el-col>
            <el-col :md='8'>
                <el-form-item label='MaximumGroupSize' >
                    <el-input-number class='full-width' v-model='selectedObject.MaximumGroupSize' :precision='0' :max='999999'></el-input-number>
                </el-form-item>
            </el-col>            </el-row>
        </el-form>
        <span slot="footer" class="dialog-footer" >
            <el-button @click="showPopup=false"     > Renunta  </el-button>
            <el-button type="primary" @click="save" > Salveaza </el-button>
        </span>
    </el-dialog>
</template>

<script>
    import settings from "@/backend/LocalSettings";
    import BasePage from '@/pages/BasePage';

    export default {
        name: "Clubstables_dialog",
        extends: BasePage,
        data () {
            return {
                baseUrl :'',
                showPopup: false,
                mode: 'add',
                selectedObject: {
                    IdClub:-1, Name: '' , Description: '' , MinimumAmmount: '10' , MaximumGroupSize: '100' 
                },
                Info:{
                    clubs: []
                },
                rules: {
                    //   Nume: [ { required: true, message: "Campul este obligatoriu" } ]
                    Name: [ { required: true, message: 'Campul este obligatoriu' } ], 
                    Description: [ { required: true, message: 'Campul este obligatoriu' } ], 
                    MinimumAmmount: [ { required: true, message: 'Campul este obligatoriu' } ], 
                    MaximumGroupSize: [ { required: true, message: 'Campul este obligatoriu' } ], 
                }
            }
        },
        methods: {
            show_me: async function( id ) {
                this.showPopup        = true;
                if( id == null )
                {
                    this.mode = "add";
                }
                else
                {
                    this.mode             = "edit";
                    var            result = await this.post("clubstables/get_info_item_dialog", { id: id } );
                    this.selectedObject   = result.Item;
                }
            },
            async get_info(){
                var response = await this.post("clubstables/get_info_for_dialog" );
                this.Info.clubs = response.clubs;
            },
            save: async function() {
                this.$refs['my-form'].validate( async(valid) => {
                    if (valid)
                    {
                        await this.post("clubstables/save", { mode: this.mode, object: this.selectedObject } );
                        this.showPopup = false;
                        this.$emit("save");
                    }
                });
            }
        },
        mounted: function() {
            this.baseUrl = settings.BASE_URL;
            this.get_info();
        }
    };
</script>

<style lang="less" scoped>
    .full-width {
        width: 100%;
    }

</style>